import styled from 'styled-components';

export const SectionHeaderContainer = styled.div`
  h3 {
    line-height: 1;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    margin-right: 10px;
  }

  p {
    margin: 0;
    margin-top: 6px;
    color: rgba(73, 80, 87, 1);
  }

  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  min-height: 34px;

  .title-container {
    display: flex;
  }

  .section-header-buttons {
    display: flex;
    align-items: center;
    gap: 10px;

    button {
      margin-left: 10px;

      span.glyphicon {
        margin-right: 5px;
        font-size: 12px;
      }
    }
  }
`;
